import usePermissions from './usePermissions';
import { roleHasWallet } from '../constants/keycloak';
import type { CRMApiEntityType, UserRole } from '../@types/api';

type WalletAccessParams = {
  userType: CRMApiEntityType;
  partnerRole?: UserRole;
};

const useWalletAccess = ({ userType, partnerRole }: WalletAccessParams) => {
  const { hasPermission } = usePermissions();

  // Customers (players) always have wallets; partners depend on their role
  const isCustomer = userType === 'customer';
  const hasWallet = isCustomer || roleHasWallet(partnerRole);

  return {
    canViewBalance: hasPermission('viewCustomerBalances') && hasWallet,
    canUpdateBalance: hasPermission('updateCustomerBalances') && hasWallet,
  };
};

export default useWalletAccess;
